import {
  WithApplicationFromRoute
} from '@features/applications/components/with-application-from-route.tsx';
import { ServiceLocationStep } from '@features/wizard/components/service-location-step.tsx';

const ServiceLocationPage = WithApplicationFromRoute(ServiceLocationStep);

export default ServiceLocationPage;
